export const url = `https://api.monstersofthesea.io`;
// export const url = `http://localhost:9000`;